var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.998,
    height: 6.248,
    viewBox: "0 0 29.998 26.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-home",
    d: "M14.824-12.823l-3.574-2.92v-4.535a.352.352,0,0,0-.352-.352H9.727a.352.352,0,0,0-.352.352v3.008L1.183-23.957A1.876,1.876,0,0,0,0-24.374a1.884,1.884,0,0,0-1.184.417L-14.824-12.823a.468.468,0,0,0-.173.364.467.467,0,0,0,.1.3l.592.727a.468.468,0,0,0,.363.173.468.468,0,0,0,.293-.1l2.394-1.956V.915a.938.938,0,0,0,.938.937h7.5A.938.938,0,0,0-1.875.915v-7.5l3.75.018v7.5a.938.938,0,0,0,.938.938l7.5-.019A.938.938,0,0,0,11.25.918V-13.323l2.394,1.956a.467.467,0,0,0,.3.1.468.468,0,0,0,.364-.173l.592-.727a.466.466,0,0,0,.1-.295A.468.468,0,0,0,14.824-12.823ZM9.369-.015h.006L3.749,0v-7.51a.941.941,0,0,0-.935-.937L-2.81-8.46h0a.938.938,0,0,0-.937.938V-.015H-9.375V-14.853L0-22.5l9.375,7.651Z",
    transform: "translate(14.998 24.373)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.504abbba3812f988fa6657a9c666c884.svg";
export { ForwardRef as ReactComponent };